<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <!-- <imgBigCards></imgBigCards> -->
    <!-- 模块1 -->

    <!-- 提示 -->
    <!-- <el-alert
      class="my-alert-3"
      title="名称"
      description="践行企业社会价值，天利教育常年开展面向教育欠发达地区的图书捐赠，助力教育均衡发展"
      type="warning"
      show-icon
    /> -->

    <!-- 内容盒子 -->
    <div class="correction-content">
      <p>申请捐赠</p>
      <!-- 输入框 + 按钮 盒子 -->
      <div class="text-input">
        <el-form
          style="max-width: 343px"
          :model="mydata.form"
          :rules="mydata.rules"
          label-width="auto"
          class="demo-ruleForm"
          ref="formEl"
          label-position="top"
        >
          <el-form-item
            label="申请单位名称"
            prop="unit_name"
            class="this-title1"
          >
            <el-input v-model="mydata.form.unit_name" />
          </el-form-item>

          <el-form-item label="省/市" prop="province_city" class="this-title2">
            <!-- <el-input v-model="mydata.form.province_city" /> -->
            <el-cascader
              :options="pcTextArr"
              v-model="mydata.form.province_city"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item label="单位地址" prop="address" class="this-title3">
            <el-input v-model="mydata.form.address" />
          </el-form-item>

          <el-form-item label="联系人姓名" prop="contacts" class="this-title4">
            <el-input v-model="mydata.form.contacts" />
          </el-form-item>

          <el-form-item label="联系人电话" prop="phone" class="this-title4">
            <el-input v-model="mydata.form.phone" />
          </el-form-item>

          <el-form-item label="图书需求说明" prop="explain" class="this-title1">
            <el-input
              placeholder="请简要说明申请单位图书需求，包括数量、内容、学科、年级等。"
              type="textarea"
              v-model="mydata.form.explain"
            />
          </el-form-item>
        </el-form>

        <!-- 提交按钮 -->
        <el-button
          type="primary"
          @click="submitButton"
          :loading="mydata.btnLoading"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ArrowRight } from "@element-plus/icons-vue";
import { ref, reactive } from "vue";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";

import { pcTextArr } from "element-china-area-data";
// 引入图书捐赠申请接口
import { bookDonateList } from "@/api/teacherHand/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",

  form: {
    unit_name: "",
    province_city: "",
    address: "",
    contacts: "",
    phone: "",
    explain: "",
  },

  rules: {
    unit_name: [
      {
        required: true,
        message: "请填写申请捐赠单位的准确名称",
        trigger: "blur",
      },
    ],
    province_city: [
      {
        required: true,
        message: "点击下拉列表选择省、市",
        trigger: "blur",
      },
    ],
    address: [
      {
        required: true,
        message: "请填写申请单位详细地址",
        trigger: "blur",
      },
    ],
    contacts: [
      {
        required: true,
        message: "请填写联系人姓名",
        trigger: "blur",
      },
    ],
    phone: [
      {
        required: true,
        message: "请准确填写联系人电话信息",
        trigger: "blur",
      },
    ],
    explain: [
      {
        required: true,
        message: "请填写捐赠需求说明",
        trigger: "blur",
      },
    ],
  },
  btnLoading: false,

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
  // articleId: "", //文章id
});

const formEl = ref(null);

// mydata.articleId = route.query.id;

//点击事件
function submitButton() {
  formEl.value.validate((valid, fields) => {
    if (valid) {
      // 调用图书捐赠申请
      bookDonateList(mydata.userInfo.jwt, {
        ...mydata.form,
        province_city: mydata.form.province_city.join(""),
      }).then((res) => {
        // console.log("教师加入", res);
        // 提示弹窗
        ElMessage({
          message: res.msg,
          type: "success",
        });
        // mydata.enterActivitiesList = res.data;
      });
    }
  });
}

// function handleClick(tab) {
//   console.log(tab);
// }

//按钮的事件函数
// function submit() {

// console.log(mydata.zhanghao, mydata.mima);
// mydata.btnLoading = true;
// axios({
//   method: "post",
//   url: "/house/login/login",
//   data: {
//     //请求参数（get请求的时候必须用params，post请求的时候必须用data）
//     account: mydata.zhanghao,
//     password: mydata.mima,
//     // sourceText: mydata.zhanghao + mydata.mima, //sourceText就是这次项目的后端跟你说的必须用什么属性名，否则后端就拿不到了；属性值是我要传给后端的内容
//   },
// }).then((res) => {
//   mydata.btnLoading = false;
//   if (res.data.code === 1) {
//     ElMessage({
//       message: res.msg,
//       type: "success",
//     });

//     // 存储后端返回的token值
//     localStorage.setItem("token", res.data.data.token);
//     localStorage.setItem("adminName", mydata.zhanghao);

//     // 跳转页面
//     router.push({
//       path: "/layout/list/personalCenter/personalInfor/index.vue",
//     });

//     mydata.zhanghao = "";
//     mydata.mima = "";
//   }
// });
// }
</script>

<style scoped lang="scss">
.books-details {
  background-color: #ffffff;
  overflow: hidden;
  // border: 1px solid red;
  padding-top: 16px;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  //////提示
  :deep(.el-alert.el-alert--warning.is-light) {
    // width: 1200px;
    height: 70px;
    margin: 0 auto;
    // border: 1px solid #8f93ff;
    background-color: #eae6ff;
    border-radius: 0px;
    margin-bottom: 20px;
    border-radius: 8px;

    //图标
    .el-icon.el-alert__icon {
      display: none;
    }
    ////名称
    .el-alert__title.with-description {
      font-size: 16 !important;
      font-weight: 500;
      color: #000000d9;
    }
    ///描述
    .el-alert__description {
      font-size: 14;
      font-weight: 400;
      color: #999999;
    }

    //// x号
    .el-icon.el-alert__close-btn {
      display: none;
      // color:red;
    }
  }

  //内容盒子
  .correction-content {
    // width: 1200px;
    width: 343px;
    margin: 0 auto;
    //活动报名
    > p {
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
      text-align: center;
      line-height: 50px;
      text-shadow: 0px 2px 8px 0px #0000004d;
      background-color: #009de0;
      border-radius: 8px;
    }

    ////// 输入框 + 按钮 盒子  ////////////////////////////////////
    .text-input {
      width: 343px;
      // height: 822px;
      margin: 0 auto;
      // border: 1px solid blue;
      margin-top: 20px;
      overflow: hidden;

      :deep(.el-form-item) {
        // flex-direction: column;
        .el-input__wrapper {
          height: 40px;
        }
      }

      //下拉框
      :deep(.el-form-item.is-required.asterisk-left) {
        // 字体
        // .el-form-item__label-wrap {
        //   // border: 1px solid red;
        //   margin-left:0px !important;
        // }
        // 下拉框高度
        .el-select__wrapper.el-tooltip__trigger.el-tooltip__trigger {
          height: 40px;
        }
      }

      //输入框、textarea的长度（包括字体）
      :deep(.el-form-item.is-required.asterisk-left) {
        width: 343px;
        margin-bottom: 16px;
        //字体
        .el-form-item__label {
          color: #333333;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 1px;
          // text-align: left;
        }
      }


      //textarea框
      :deep(.el-textarea__inner) {
        min-height: 76px !important;
        // border:1px solid red;
      }

      //上传附件
      // :deep(.el-button.el-button--default) {
      //   // border: 1px solid red;
      //   width: 422px;
      // }
      // //提示文字
      // :deep(.el-button.submit-button > span) {
      //   // border: 1px solid red;
      //   width: 422px;
      //   text-align: left !important;
      //   font-size: 14px;
      //   font-weight: 400;
      //   color: #000000;
      //   letter-spacing: 1px;
      //   margin-left: -5px;
      // }
      // //上传附件的 文件名
      // :deep(.el-upload-list.el-upload-list--text) {
      //   // border:1px solid red;
      //   // 文本图标
      //   .el-icon.el-icon--document {
      //     // color:red;
      //   }
      //   // 文字
      //   .el-upload-list__item-file-name {
      //     color: #009de0;
      //   }
      // }

      ////// 按钮
      :deep(.el-button.el-button--primary) {
        width: 343px;
        height: 40px;
        border-radius: 4px;
        margin-top: 40px;
        // margin-bottom: 40px;

        > span {
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
}

:deep(.el-cascader) {
  width: 100%;
}
</style>
